"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSurveyTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const circle_background_svg_1 = __importDefault(require("../../assets/images/circle-background.svg"));
const CircleBackgroundAnimation_1 = require("../../context/CircleBackgroundAnimation");
const Progress_1 = require("../../context/Progress");
const PageNavigator_1 = require("../../molecules/PageNavigator/PageNavigator");
const router_1 = require("../../router");
const mediaQueries_1 = require("../../styles/mediaQueries");
/**
 * Main template for pages
 * @constructor
 */
function ProfileSurveyTemplate() {
    var _a;
    const [progressState] = (0, Progress_1.useProgress)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const outlet = (0, react_router_dom_1.useOutlet)();
    const [isPageNavigatorVisible, setIsPageNavigatorVisible] = (0, react_1.useState)(false);
    const [isCircleAnimating, setIsCircleAnimating] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (location.pathname.endsWith(router_1.Route.ProfileComplete)) {
            setIsCircleAnimating(true);
        }
    }, [location]);
    (0, react_1.useEffect)(() => {
        setIsPageNavigatorVisible(progressState.currentPage > 0 &&
            progressState.currentPage < progressState.pagesCount - 1);
    }, [progressState.currentPage, progressState.pagesCount]);
    const [{ imageHeight, imageWidth, imageLeft }] = (0, CircleBackgroundAnimation_1.useCircleBackgroundAnimation)();
    /**
     * Go to previous page
     */
    const onGoBack = () => {
        /**
         * Hide page navigator if user goes back to the first page
         */
        if (progressState.currentPage === 1) {
            setIsPageNavigatorVisible(false);
        }
        navigate(-1);
    };
    const onGoNext = () => {
        if (progressState.canGoNext && progressState.nextRoute) {
            /**
             * Hide page navigator if user goes to the last page
             */
            if (progressState.currentPage === progressState.pagesCount - 2) {
                setIsPageNavigatorVisible(false);
            }
            navigate(progressState.nextRoute, {
                state: { canGoBack: true },
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledPageNavigator, { pageCount: progressState.pagesCount, currentPage: progressState.currentPage, onGoNext: onGoNext, onGoBack: onGoBack, canGoBack: ((_a = location.state) === null || _a === void 0 ? void 0 : _a.canGoBack) || false, canGoNext: progressState.canGoNext, show: isPageNavigatorVisible, "data-e2e": 'ProfileSurveyTemplate_StyledPageNavigator' }), (0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'ProfileSurveyTemplate_Content', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isCircleAnimating, timeout: 200, onEntered: () => setIsCircleAnimating(false), "data-e2e": 'ProfileSurveyTemplate_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledCircleIcon, { style: {
                                height: imageHeight,
                                width: imageWidth,
                                left: imageLeft,
                            }, "data-e2e": 'ProfileSurveyTemplate_StyledCircleIcon' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.SwitchTransition, { mode: "out-in", "data-e2e": 'ProfileSurveyTemplate_SwitchTransition', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { addEndListener: (node, done) => node.addEventListener('transitionend', done, false), appear: true, "data-e2e": 'ProfileSurveyTemplate_CSSTransition', children: (0, jsx_runtime_1.jsx)(OutletWrapper, { "data-e2e": 'ProfileSurveyTemplate_OutletWrapper', children: outlet }) }, location.key) })] })] }));
}
exports.ProfileSurveyTemplate = ProfileSurveyTemplate;
const OutletWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;

  &.enter,
  &.appear {
    opacity: 0;
  }

  &.enter-active,
  &.appear-active {
    opacity: 1;

    transition: opacity 200ms ease-in;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;

    transition: opacity 200ms ease-in;
  }
`;
const StyledCircleIcon = (0, styled_components_1.default)(circle_background_svg_1.default) `
  position: absolute;

  display: none;

  ${mediaQueries_1.device.desktop `
    display: block;
  `}

  &.enter-active {
    transition: left 200ms ease-in;
  }
`;
const StyledPageNavigator = (0, styled_components_1.default)(PageNavigator_1.PageNavigator) `
  margin-bottom: 28px;

  ${mediaQueries_1.device.mobileLandscape `
    margin-bottom: 16px;
  `}

  ${mediaQueries_1.device.desktop `
    margin-bottom: 20px;
  `}
`;
const Content = styled_components_1.default.div `
  height: 100%;

  overflow-y: auto;

  position: relative;
`;
